import { Currency } from '@kanbu/schema/enums';
import { CreditCurrencyRates } from '@kanbu/schema/shared';
import { formatUtils } from '@kanbu/shared';

import { AppSettings } from '@/constants/AppSettings';

/**
 * Default 5× org margin, in credits (USD-equivalent).
 *
 * check  — one Firecrawl scrape ($0.003 × 5 = $0.015 → 0.35 Kč)
 * update — pointing cleanup: ($0.003 scrape + ~$0.0005 LLM) × 5 = ~$0.0175.
 * Legacy rollout retains the $0.09 estimate. These are typical estimates,
 * not guarantees: long pages, retries and OCR have different costs.
 *
 * Formatted with 2 decimal places (not formatUtils.credits, which snaps
 * amounts within 0.1 of a whole number — 2.07 Kč would become 2 Kč).
 */
const AUTO_UPDATE_COST_CREDITS = {
  check: 0.015,
  update: 0.0175,
  legacyUpdate: 0.09,
} as const;

function formatSmallCreditCost(credits: number, currency: Currency): string {
  const amount =
    Math.round(credits * CreditCurrencyRates[currency] * 100) / 100;

  return formatUtils.currency(amount, currency);
}

export function formatAutoUpdateCosts(
  currency: Currency | null | undefined,
  pageCleaningEnabled = AppSettings.pageCleaningEnabled,
): {
  check: string;
  update: string;
} {
  const resolved = currency ?? Currency.CZK;

  return {
    check: formatSmallCreditCost(AUTO_UPDATE_COST_CREDITS.check, resolved),
    update: formatSmallCreditCost(
      pageCleaningEnabled
        ? AUTO_UPDATE_COST_CREDITS.update
        : AUTO_UPDATE_COST_CREDITS.legacyUpdate,
      resolved,
    ),
  };
}
